import React from 'react'
import { Form, Loader, Panel, SelectPicker } from 'rsuite'
import { usePartnerSettings } from '@@partner:helpers/hooks/auth'

import SettingsTopMenu from '@components/settings/SettingsTopMenu'

import {
  UI_SETTING_COLOR_SCHEME,
  UI_SETTINGS_DEFAULT_COLOR_SCHEME,
  UI_SETTINGS_COLOR_SCHEMES
} from '@@partner:config/ui-settings'
import AppLoader from '@components/common/AppLoader'

export default function SettingsPage () {
  const { getSetting, updateSetting, isSettingLoading } = usePartnerSettings()

  return (
    <div className="SettingsPage">
      <h1 className="u-heading">Настройки</h1>
      <SettingsTopMenu />
      <Panel shaded>
        <Form layout="horizontal">
          <Form.Group className="relative flex items-center">
            <Form.ControlLabel>Тема оформления</Form.ControlLabel>
            <SelectPicker
              className="w-64"
              block
              searchable={false}
              cleanable={false}
              data={UI_SETTINGS_COLOR_SCHEMES}
              value={getSetting(
                UI_SETTING_COLOR_SCHEME,
                UI_SETTINGS_DEFAULT_COLOR_SCHEME
              )}
              onSelect={(theme) =>
                updateSetting(UI_SETTING_COLOR_SCHEME, theme)
              }
            />
            {isSettingLoading(UI_SETTING_COLOR_SCHEME) && (
              <AppLoader.FieldProgress className="ml-5" />
            )}
          </Form.Group>
        </Form>
      </Panel>
    </div>
  )
}
